import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    'Defina VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY no .env (veja .env.example).'
  )
}

const supabaseOptions = {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'wappdesk-voice-auth',
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    flowType: 'pkce',
  },
  realtime: {
    params: { eventsPerSecond: 50 },
    heartbeatIntervalMs: 5000,
    timeout: 10000,
  },
  db: { schema: 'public' },
  global: {
    headers: { 'X-Client-Info': 'wappdesk-voice' },
  },
}

export const supabase = createClient(supabaseUrl ?? '', supabaseAnonKey ?? '', supabaseOptions)
